import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Folder14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.5 0.75C0.809644 0.75 0.25 1.30964 0.25 2V11.5C0.25 12.1904 0.809645 12.75 1.5 12.75H12.5C13.1904 12.75 13.75 12.1904 13.75 11.5V4.5C13.75 3.80964 13.1904 3.25 12.5 3.25H7.81066L5.67678 1.11612C5.44236 0.881696 5.12441 0.75 4.79289 0.75H1.5ZM1.75 3.25V2.25H4.68934L5.68934 3.25L1.75 3.25ZM1.75 4.75V11.25H12.25V4.75C8.57385 4.75 5.39031 4.75 1.75 4.75Z'
      fill='currentColor'
    />
  </Svg>
);

Folder14.displayName = 'Folder14';
export default Folder14;
